import { Injectable } from '@angular/core';

import { ApiService, LogService, AppContext } from './../../../shared';
@Injectable()
export class EmailScheduleService {
  constructor(private api: ApiService, private logger: LogService, private app: AppContext) {
  }

  set(params: any, body: any) {
    return this.api.getApiClient().then(client => this.callSet(client, params, body));
  }

  callSet(apigClient: any, paramsToSend, bodyToSend): Promise<any> {
    this.logger.log('email-schedule.service', 'callSet', paramsToSend);
    this.logger.log('email-schedule.service', 'callSet', bodyToSend);
    return new Promise((resolve, reject) => {
      let params = paramsToSend;
      let body = bodyToSend;
      let additionalParams = { headers: { 'Content-Type': 'application/json' } };
      try {
        apigClient.userEmailDeliverySchedulesPost(params, body, additionalParams)
          .then((result) => {
            this.logger.log('email-schedule.service', 'post result', result);
            let schedule = result.data.emailSchedules[result.data.emailSchedules.length - 1];
            resolve(schedule);
          }).catch((err) => {
            reject(err);
            this.api.handleError(err);
          });
      } catch (ex) {
        reject('error occurred');
      }
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/account/email-delivery/email-schedule/email-schedule.service.ts